import { toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject, tv } from '@costar-ui/cosmos';
import popoverOptions from '../../common/popover-options/popover-options.esm.js';

var tooltipTvObject = getTvObject({
  base: [].concat(_toConsumableArray(popoverOptions.base), ['min-h-[52px] min-w-[72px] max-w-[--max-tooltip-width]']),
  variants: popoverOptions.variants
});
var tooltipStyles = tv(tooltipTvObject);

export { tooltipStyles };
//# sourceMappingURL=tooltip.styles.esm.js.map
